import { render, staticRenderFns } from "./AdminRoles.vue?vue&type=template&id=db4d68a6"
import script from "./AdminRoles.vue?vue&type=script&lang=js"
export * from "./AdminRoles.vue?vue&type=script&lang=js"
import style0 from "./AdminRoles.vue?vue&type=style&index=0&id=db4d68a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../BuildingCatalog/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports